import Big, { bigZero } from '../../../math/math';
import type { WorkDayDto } from '../../../api/generated/v2/generated/data-contracts';
import { isWorkDay } from './isWorkDay';
import { roundToStep } from './roundToStep';

export type DistributeResult = { ok: true; distribution: Record<string, Big> } | { ok: false };

export const distributeTotal = (totalValue: Big, dates: string[], workWeek: WorkDayDto[], roundingInterval: number): DistributeResult => {
    const checkWorkDay = isWorkDay(workWeek);
    const workdays = dates.filter(checkWorkDay);

    // If no workdays exist in the period, fall back to all dates
    const targetDates = workdays.length > 0 ? workdays : dates;

    if (targetDates.length === 0) {
        return { ok: false };
    }

    // Zero total: return zeros for target dates
    if (totalValue.eq(bigZero)) {
        const distribution: Record<string, Big> = {};
        for (const date of targetDates) {
            distribution[date] = bigZero;
        }
        return { ok: true, distribution };
    }

    const count = new Big(targetDates.length.toString());
    const perDay = totalValue.div(count);
    const roundedPerDay = roundToStep(Number(perDay.toString()), roundingInterval);

    const distribution: Record<string, Big> = {};
    let sum = bigZero;

    for (const date of targetDates) {
        distribution[date] = roundedPerDay;
        sum = sum.plus(roundedPerDay);
    }

    if (!sum.eq(totalValue)) {
        return { ok: false };
    }

    return { ok: true, distribution };
};
